module.exports = __webpack_public_path__ + "img/2nd.082fd5db.png";